import type { PrimeStyleClassNames } from "../../types";
import type { TranslateFn } from "../../i18n";
import { cx } from "../utils/classnames";
import { useIsMobile } from "../utils/useIsMobile";

export function ErrorView({
	productImage,
	productTitle,
	title,
	message,
	onManualMeasurements,
	cn,
	t,
}: {
	productImage?: string;
	productTitle?: string;
	title?: string;
	message?: string;
	onManualMeasurements: () => void;
	cn: PrimeStyleClassNames;
	t: TranslateFn;
}) {
	const isMobile = useIsMobile();
	const heading = title?.trim() || t("Something went wrong");
	const body = message?.trim() || t("Please try again or use manual measurements.");

	const RightColumn = (
		<div className={cx("ps-tryon-no-chart-content ps-tryon-error-fallback", cn.error)}>
			<div className="ps-tryon-no-chart-icon ps-tryon-error-fallback-icon" aria-hidden="true">
				<svg viewBox="0 0 24 24" width="44" height="44" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
					<path d="M12 3l8.5 15H3.5L12 3z" />
					<path d="M12 9v4" />
					<path d="M12 17h.01" />
				</svg>
			</div>
			<h3 className="ps-tryon-no-chart-title">{heading}</h3>
			<p className={cx("ps-tryon-no-chart-msg", cn.errorText)}>
				{body}
			</p>
			<div className="ps-tryon-no-chart-actions">
				<button type="button" onClick={onManualMeasurements} className={cx("ps-tryon-no-chart-cta", cn.submitButton)}>
					{t("Try manual measurements")} &rarr;
				</button>
			</div>
		</div>
	);

	if (isMobile) {
		return (
			<div className="ps-tryon-sr">
				{productImage && (
					<div className="ps-tryon-sr-img-col" style={{ flex: "0 0 auto", maxHeight: "38vh" }}>
						<img src={productImage} alt={productTitle || ""} className="ps-tryon-sr-product-img" />
					</div>
				)}
				<div className="ps-tryon-no-chart-right-col">{RightColumn}</div>
			</div>
		);
	}

	return (
		<div className="ps-tryon-sr">
			<div className="ps-tryon-sr-split">
				<div className="ps-tryon-sr-img-col">
					{productImage && (
						<img src={productImage} alt={productTitle || ""} className="ps-tryon-sr-product-img" />
					)}
				</div>
				<div className="ps-tryon-sr-right-col ps-tryon-no-chart-right-col">
					{RightColumn}
				</div>
			</div>
		</div>
	);
}
